import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { InspectionVentilationSystemAndFireProtection } from '@authority-labs/api-interfaces';
import { Base1001TestResultsComponent } from '../../base-1001-certificate';

@Component({
  selector:
    'authority-labs-ventilation-system-and-fire-protection-test-results',
  templateUrl:
    './ventilation-system-and-fire-protection-test-results.component.html',
  styleUrls: [
    './ventilation-system-and-fire-protection-test-results.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class VentilationSystemAndFireProtectionTestResultsComponent
  extends Base1001TestResultsComponent
  implements OnInit
{
  @Input() inspection: InspectionVentilationSystemAndFireProtection;

  ngOnInit(): void {
    this.init(
      this.inspection.cases,
      new InspectionVentilationSystemAndFireProtection(
        this.inspection
      ).getNotes()
    );
  }
}
